import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

export class GsmLetContext {
  $implicit: any = null;
  gsmLet: any = null;
}

@Directive({
  selector:   '[gsmLet]',
  standalone: true
})
export class GsmLetDirective implements OnInit {
  private _vcr = inject(ViewContainerRef);
  private _templateRef = inject<TemplateRef<GsmLetContext>>(TemplateRef);

  private _context = new GsmLetContext();

  @Input()
  set gsmLet(value: any) {
    this._context.$implicit = this._context.gsmLet = value;
  }

  ngOnInit() {
    this._vcr.createEmbeddedView(this._templateRef, this._context);
  }
}
